import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=3978b4d6&"
import script from "./StaffList.vue?vue&type=script&lang=ts&"
export * from "./StaffList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports